var getAllRelationshipPoliciesOwnedByCourse = function(owner_course_id, order) {
  if (!warnIfUnsavedChangeInRelationshipPolicy()) {
    return false
  }

  // If the user selects the blank/prompt value, clear the page
  if (owner_course_id == "") {
    $("#all_relationship_policies").html('');
    setRelationshipPolicyOrigData();
    return true;
  }

  $.ajax({
    url: '/relationship_policies/get_relationship_policies/',
    data:{
      owner_course_id: owner_course_id,
      order: order
    },
    success: function(response) {
      $("#all_relationship_policies").html(response);
      setRelationshipPolicyOrigData();
    },
    fail: function(response){alert('Unable to complete request. Please try later.')}
  });
}

var setRelationshipPolicyOrigData = function() {
  if ($("#relationship_policy_form").length > 0) {
    relationship_policy_orig_data = $("#relationship_policy_form").find("input[type!='hidden']").serialize();
  }
}

$(function() {
  var relationship_policy_orig_data;
  setRelationshipPolicyOrigData();

  // Set up event handlers to toggle all Course-specific checkboxes if a master checkbox is clicked
  var selectors = [
    {master_checkbox_selector: "input#visible_to_all[type='checkbox']", sub_checkboxes_selector: "input.visibility[type='checkbox']"},
    {master_checkbox_selector: "input#diff_pricing_to_all[type='checkbox']", sub_checkboxes_selector: "input.diff_pricing[type='checkbox']"}
  ];
  $.each(selectors, function( index, obj ) {
    $(document).on('change', obj.master_checkbox_selector, function(e) {
      $(obj.sub_checkboxes_selector).not("[disabled]").prop('checked',this.checked).change();
    });
  });

  // Disable the diff_pricing text input unless the is_diff_pricing checkbox is checked
  $(document).on('change', "input.diff_pricing[type='checkbox']", function(e) {
    var relationshipPolicyId = this.id.split('_')[2];
    var checkboxChecked = $(this).is(':checked');
    $("#relationship_policy_" + relationshipPolicyId + "_diff_pricing").prop("disabled", !checkboxChecked);
  });

  // Warn if the user tries to navigate away using a link and there are unsaved changes
  $(document).on("click", "a", function(e) {
    return warnIfUnsavedChangeInRelationshipPolicy()
  });

});

var warnIfUnsavedChangeInRelationshipPolicy = function(){
  if ($("#relationship_policy_form").length > 0) {          
    if (($("#relationship_policy_form").find("input[type!='hidden']").serialize() != relationship_policy_orig_data)){
      if (confirm('Would you like to save the changes made?')) { 
        $("#submit_course_relationship_policy").submit();           
        return false;
      }  
    }
  }
  return true
}
